<template>
	<div class="masonry-item">
		<TypographyTitle :level="4">{{ $t(headerKey) }}</TypographyTitle>
		<Card :bordered="false">
			<slot></slot>
		</Card>
	</div>
</template>
<script>
import { TypographyTitle, Card } from 'ant-design-vue';

export default {
	components: {
		TypographyTitle, Card,
	},
	props: ['headerKey'],
};
</script>
<style scoped>
.masonry-item {
	display: inline-block;
	margin: 0 0 1em;
	width: 100%;
}
</style>
